export const bbaViewDefaults = {
  serviceFilters: { category: '', governanceStanding: '', institutionalCategory: '', reputationRisk: '', query: '' },
  campaignFilters: { type: '', status: '', governanceStanding: '', reputationRisk: '', query: '' },
  partnerFilters: { type: '', partnershipLevel: '', governanceStanding: '', query: '' },
};
